import { useMutation } from "react-query";
import { addBusinessType } from "../../../../../actions/Utilities/BusinessType";
import { toast } from "components/toastNotification";
import { IBusinessType } from "../type/BusinessTypeInterface";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateAgreementBusinessType,
  businessTypeRefetching,
} from "../atoms/atoms";

const useAddBusinessType = () => {
  const setActionAddState = useSetRecoilState(addStateAgreementBusinessType);
  const [isReFetching, setIsReFetching] = useRecoilState(
    businessTypeRefetching
  );
  const { mutate } = useMutation(
    (NewData: IBusinessType) => addBusinessType(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Business Type Added Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Business Type Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Business Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Business Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Adding Business Type failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Adding Business Type failed", res.Message, "error");
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Business Type failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddBusinessType;
